import { DownOutlined } from '@ant-design/icons';
import { useTranslation } from '@framework/i18n';
import { Button, Popover, PopoverProps } from 'antd';
import React from 'react';
import styled from 'styled-components';

const StyledPickerWrapper = styled.div`
  &&& {
    .color-picker {
      box-shadow: none !important;
      border: none;
      margin-right: -6px;
      margin-bottom: -6px;

      > div {
        padding: 0 !important;
      }
    }
  }
`;

const StyledButton = styled(Button)`
  &&& {
    padding: 0;
    overflow: hidden;
    display: flex;
    align-items: center;
  }
`;
const StyledButtonText = styled.div`
  width: 50%;
`;

const StyledColorBox = styled.div<{ color: string }>`
  width: 50%;
  height: 100%;
  background-color: ${props => props.color};
  color: #fff;
`;

export interface IColorInputPopoverProps
  extends Omit<PopoverProps, 'title' | 'content' | 'children'> {
  picker: React.ReactNode;
  color: string;
}

export function ColorInputPopover(props: IColorInputPopoverProps) {
  const { picker, color, ...otherProps } = props;
  const { t } = useTranslation();

  return (
    <Popover
      placement="bottomLeft"
      trigger="click"
      {...otherProps}
      content={<StyledPickerWrapper>{picker}</StyledPickerWrapper>}
    >
      <StyledButton block size="large">
        <StyledButtonText>
          {t('inputs.color.select', 'Seleziona Colore')} <DownOutlined />
        </StyledButtonText>
        <StyledColorBox color={color}></StyledColorBox>
      </StyledButton>
    </Popover>
  );
}
